import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { CryptoService } from '@bt/core/services/crypto.service';
import { CryptoBalanceModel } from '@bt/core/models/cryptoBalance.model';
import { NotifierService } from 'angular-notifier';
import {faCopy } from '@fortawesome/free-solid-svg-icons';
import { IResponse } from '@bt/shared';
import { MyChartPieComponent } from '@bt/shared/charts/chart-pie/chart-pie.component';
import { PercentageBalanceModel } from '@bt/shared/charts/chart-pie/models/percentageBalance.model';

@Component({
  selector: 'app-crypto-balances',
  templateUrl: './crypto-balances.component.html',
  styleUrls: ['./crypto-balances.component.scss']
})
export class CryptoBalancesComponent extends BaseComponent{
  @ViewChild(MyChartPieComponent) chartBar: MyChartPieComponent;

  faCopy = faCopy;
  constructor(
    private cryptoService: CryptoService,
    private notifierService: NotifierService
  ) 
  {
    super();
    this.isResponsed = false;
  }

  public balances: CryptoBalanceModel[] = [];
  public hasInfo: boolean = false;
  public isResponsed: boolean;
  public chartsData: PercentageBalanceModel[];
  public balanceCost: number = 0;

  ngOnInit() {
    this.setLoading(true);
    this.loadBalances();
  }

  public loadBalances(): void{    
    this.cryptoService.getAllCryptoBalances()
    .then((resp: any) => {
      if(resp.data.length != 0) {
        this.balances = resp.data;
        this.chartsData = this.balances.map(x => ({
          name: x.cryptoName, 
          value: x.percentageBalanceCost
        }));
        this.hasInfo = true;
      }
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error: any) => {
      this.isResponsed = true;
      this.notifierService.notify('error', error.message);
      this.setLoading(false);
    });
    
    this.cryptoService.getBalanceCost()
      .then((response: IResponse<number>) => {
        this.balanceCost = Number.isNaN(response.data) ? 0 : response.data;
        this.setLoading(false);
      })
      .catch((error: any) => {
        this.notifierService.notify('error', error.message);
        this.setLoading(false);
      });
  }

  public copyToClipboard(text: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.notifierService.notify('success', 'Адрес скопирован!');
  }
}


// WEBPACK FOOTER //
// ./src/app/crypto-balances/crypto-balances.component.ts